<template>
  <div v-if="flights && flights.length">
    <v-card
      v-for="flight in flights"
      :key="flight.id"
      class="ma-5 rounded-lg"
      outlined
    >
      <v-row justify="space-between" align="center" class="my-2 pl-2">
        <v-col cols="12" md="8">
          <v-row justify="start" align="center" v-for="(flightSegment, i) in flight.flightSegments" :key="i">
            <v-col cols="12" md="5" v-if="!flight.mailOnlyFare" class="d-flex align-start">
              <img :src="flightSegment.Segments[0].MarketingAirlineLogoSM" height="30"/>
                <div class="ml-5">
                  <v-tooltip location="bottom">
                    <template #activator="{ props }">
                      <span
                        v-bind="props"
                        class=" font-weight-medium"
                      >
                        {{ flightSegment?.Segments?.[0]?.MarketingAirlineName }}
                      </span>
                    </template>
                    <span>
                      {{ flightSegment?.Segments?.[0]?.MarketingAirlineName }}
                    </span>
                </v-tooltip>

                <p class="mb-0 caption text-grey">Operated by {{flightSegment?.Segments[0]?.OperatingAirlineName}}</p>
                <v-subheader class="text-primary d-inline-flex px-0">{{ flightSegment.Segments[0].DepartureDate}}</v-subheader>
                                -
                <v-subheader class="text-primary d-inline-flex px-0">{{ flightSegment.Segments[flightSegment.Segments.length - 1].ArrivalDate}}</v-subheader>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="pa-5" v-else>
            <v-row>
                <v-icon color="blueDark" class="mx-5">mdi-email-check</v-icon>
                 <v-icon color="blueDark lighten-1">mdi-shield-airplane</v-icon>
            </v-row>
              <p class="body-2 mt-5 mb-0">email-only-fare</p>
          </v-col>
          <v-col cols="12" md="6" class="px-5">
            <div class="d-flex justify-space-between align-center">
              <div class="airline">
                <p class="airline font-weight-bold greyText--text text-right">
                  <v-icon large color="airline greyText--text">mdi-airplane-takeoff</v-icon>
                    {{ flightSegment.Segments[0].DepartureTime }}
                    <br/>
                    {{ flightSegment.Segments[0].OriginLocationCode }}
                </p>
            </div>
        <v-tooltip
          location="bottom"
          :offset="[0, 30]"
        >
          <template #activator="{ props }">
            <p
              v-bind="props"
              class="body-2 text-primary"
            >
              {{ flightSegment?.stops }} Stops
            </p>
          </template>

        <div>
          <p
           v-for="n in flightSegment?.stops"
           :key="n"
          >
            {{flightSegment?.Segments?.[n - 1]?.DestinationLocation?.split(',')[0]}}
            -
         <span>{{ flightSegment?.Segments?.[n - 1]?.Duration }}h</span>
         </p>
        </div>
    </v-tooltip>

    <div>
     <p class="airline font-weight-bold greyText--text text-right">
        <v-icon large color="airline greyText--text">mdi-airplane-landing</v-icon>
         {{ flightSegment.Segments[flightSegment.Segments.length - 1].ArrivalTime }}
        <br/>
        {{ flightSegment.Segments[flightSegment.Segments.length - 1].DestinationLocationCode }}
        </p>
        </div>
        </div>
    </v-col>
   </v-row>
                </v-col>
                <v-col cols="12" md="4" class="price text-center py-0">
                    <div>
                        <v-chip outlined color="blueDark" class="mt-3 mb-3">{{flight.source}}</v-chip>
                        <!-- <v-chip outlined color="success" class="mb-3">{{flight.pricingInfo.fare_type}}</v-chip> -->
                        <p v-if="!flight.pricingInfo.newFare > 0" class="font-weight-black orange--text text-h6 text-center">{{flight.pricingInfo?.TotalFare?.toFixed(2)}} {{ flight.pricingInfo.TotalFare_CurrencyCode }}</p>
                        <div v-else>
                            <p v-if="flight.pricingInfo?.TotalFare" class="body-2 text-center">{{flight.pricingInfo?.TotalFare?.toFixed(2)}} {{ flight.pricingInfo.TotalFare_CurrencyCode }}</p>
                            <p class="body-1 font-weight-black text-center">- {{flight?.pricingInfo?.discount_amount}} {{ flight.pricingInfo.TotalFare_CurrencyCode }}</p>
                            <v-divider></v-divider>
                            <p v-if="flight.pricingInfo?.newFare" class="font-weight-black orange--text text-h6 text-center">{{flight.pricingInfo?.newFare?.toFixed(2)}} {{ flight.pricingInfo.TotalFare_CurrencyCode }}</p>
                        </div>
                        <p class=" grey--text lighten-1 my-0">Fare Type: {{flight?.pricingInfo?.fare_type}}</p>
                        <p v-if="flight.pricingInfo.premiumNote" class="caption success--text text-center lighten-1 my-0">{{flight?.pricingInfo?.premiumNote}}</p>
                        <v-btn  color="blueDark" :loading="loadingId === flight.offerId" elevation="0" x-large @click="select(flight.offerId, flight.offerItemIds)" class="d-block mx-auto white--text rounded-lg px-10">Select</v-btn>
                    </div>
                </v-col>
      </v-row>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import { quoteExchangeOffer, headersAuth } from '../links'

export default {
  props: ['flights', 'replaceFlight', 'deleteFlights', 'pnr', 'paxsId'],
  components: {
  },
  data () {
    return {
      loadingId: null
    }
  },
  methods: {
    select (offerId, offerItemId) {
      this.loadingId = offerId
      const body = {
        pnr: this.pnr,
        journeys_cancel: this.deleteFlights,
        journeys_replace: this.replaceFlight,
        new_offers: [
          {
            offer_id: offerId,
            offer_items: [
              {
                offer_item_id: offerItemId[0],
                pax_ref_ids: this.paxsId
              }
            ]
          }
        ]
      }
      const token = this.$store.state.user
      const header = { headers: headersAuth(token) }
      this.$http.post(quoteExchangeOffer(), body, header).then(response => {
        if (response.body.data.ndc.errors?.length) {
          this.loadingId = null
          response.body.data.ndc.errors.forEach(err => {
            this.$store.commit('showFeedback', { text: err.text, color: 'error' })
          })
        } else {
          this.loadingId = null
          this.$emit('selectFlight', response.body.data.ndc)
        }
      })
    }
  }
}
</script>
